import React from 'react'
import { Widget } from 'features/types'
import {
  TopicNotSelectedGuard,
  WidgetLoadingGuard,
  TopicIndexNotReadyGuard,
  TopicInaccessibleGuard
} from 'components/widget/share/guards'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import NoMetricGuard from '../share/Guards/NoMetricGuard'
import NoMentionGuard from '../share/Guards/NoMentionGuard'
import VocComingSoonGuard from '../share/Guards/VocComingSoonGuard'
import RunSearchEffect from '../share/RunSearchEffect'
import SummaryMetricsWidget from '../share/SummaryMetrics'

const AudienceSummaryMetricWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <TopicNotSelectedGuard widgetId={widgetId}>
      <VocComingSoonGuard widgetId={widgetId}>
        <NoMetricGuard widgetId={widgetId}>
          <RunSearchEffect widgetId={widgetId}>
            <WidgetLoadingGuard widgetId={widgetId}>
              <TopicInaccessibleGuard widgetId={widgetId}>
                <TopicIndexNotReadyGuard widgetId={widgetId}>
                  <NoMentionGuard widgetId={widgetId}>
                    <SummaryMetricsWidget widgetId={widgetId} />
                  </NoMentionGuard>
                </TopicIndexNotReadyGuard>
              </TopicInaccessibleGuard>
            </WidgetLoadingGuard>
          </RunSearchEffect>
        </NoMetricGuard>
      </VocComingSoonGuard>
    </TopicNotSelectedGuard>
  </UnexpectedErrorBoundary>
)

export default AudienceSummaryMetricWidget
